<template>
  <div class="reduction-indicator d-inline-flex align-items-center">
    <feather-icon
      :icon="iconName"
      :size="size"
      :class="`text-${variant}`"
      class="mr-25"
    />
    <b-badge
      :variant="`light-${variant}`"
      class="font-weight-bold"
    >
      {{ displayText }}
    </b-badge>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'ReductionIndicator',
  components: {
    BBadge,
  },
  props: {
    reductionPct: {
      type: Number,
      default: 0,
    },
    size: {
      type: [String, Number],
      default: '16',
    },
  },
  setup(props) {
    const variant = computed(() => {
      if (props.reductionPct >= 50) return 'success'
      if (props.reductionPct >= 25) return 'warning'
      if (props.reductionPct > 0) return 'info'
      return 'secondary'
    })

    const iconName = computed(() => {
      if (props.reductionPct >= 50) return 'TrendingDownIcon'
      if (props.reductionPct > 0) return 'ArrowDownIcon'
      return 'MinusIcon'
    })

    const displayText = computed(() => {
      if (props.reductionPct > 0) {
        return `↓ ${props.reductionPct}%`
      }
      return `→ ${props.reductionPct}%`
    })

    return {
      variant,
      iconName,
      displayText,
    }
  },
}
</script>

<style lang="scss" scoped>
.reduction-indicator {
  white-space: nowrap;
}
</style>
